import { ingredientById } from "../data/ingredients";
import { getCandidates } from "./candidates";
import { localizedIngredientName } from "./localize";
import {
  COOKING_LOCATIONS,
  FOOD_TYPES,
  type Locale,
  type SelectionState,
} from "./types";

export interface RecoveryOption {
  key: string;
  label: string;
  nextSelection: SelectionState;
  restoredCount: number;
}

export function bestRecovery(
  selection: SelectionState,
  locale: Locale = "en",
): RecoveryOption | null {
  const options: RecoveryOption[] = [];

  for (const foodTypeId of selection.foodTypeIds) {
    const label =
      FOOD_TYPES.find((option) => option.id === foodTypeId)?.label ??
      foodTypeId;
    const nextSelection = {
      ...selection,
      foodTypeIds: selection.foodTypeIds.filter((id) => id !== foodTypeId),
    };
    options.push({
      key: `food:${foodTypeId}`,
      label,
      nextSelection,
      restoredCount: getCandidates(nextSelection).length,
    });
  }
  for (const cookingLocationId of selection.cookingLocationIds) {
    const label =
      COOKING_LOCATIONS.find((option) => option.id === cookingLocationId)
        ?.label ?? cookingLocationId;
    const nextSelection = {
      ...selection,
      cookingLocationIds: selection.cookingLocationIds.filter(
        (id) => id !== cookingLocationId,
      ),
    };
    options.push({
      key: `cook:${cookingLocationId}`,
      label,
      nextSelection,
      restoredCount: getCandidates(nextSelection).length,
    });
  }
  for (const ingredientId of selection.ingredientIds) {
    const nextSelection = {
      ...selection,
      ingredientIds: selection.ingredientIds.filter(
        (id) => id !== ingredientId,
      ),
    };
    const ingredient = ingredientById.get(ingredientId);
    options.push({
      key: `ingredient:${ingredientId}`,
      label: ingredient
        ? localizedIngredientName(ingredient, locale)
        : ingredientId,
      nextSelection,
      restoredCount: getCandidates(nextSelection).length,
    });
  }
  if (selection.veganOnly) {
    const nextSelection = { ...selection, veganOnly: false };
    options.push({
      key: "diet:vegan",
      label: "Vegan only",
      nextSelection,
      restoredCount: getCandidates(nextSelection).length,
    });
  }

  return (
    options
      .filter((option) => option.restoredCount > 0)
      .sort(
        (a, b) =>
          b.restoredCount - a.restoredCount || a.key.localeCompare(b.key),
      )[0] ?? null
  );
}
